import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonModule } from '@lib/ui';
import { TranslateModule } from '@project/translate';
import { ModalPhysicianSignatureValidationComponent } from './modal-physician-signature-validation.component';

@NgModule({
  declarations: [ModalPhysicianSignatureValidationComponent],
  imports: [CommonModule, TranslateModule, ButtonModule, MatProgressSpinnerModule],
  exports: [ModalPhysicianSignatureValidationComponent],
})
export class ModalPhysicianSignatureValidationModule {}
